import { render, staticRenderFns } from "./addImageText.vue?vue&type=template&id=38b2cac6&scoped=true&"
import script from "./addImageText.vue?vue&type=script&lang=ts&"
export * from "./addImageText.vue?vue&type=script&lang=ts&"
import style0 from "./addImageText.vue?vue&type=style&index=0&id=38b2cac6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b2cac6",
  null
  
)

export default component.exports